import { useParams } from "react-router";
import styled from "styled-components";
import { GoBackButton } from "../../../components/GoBackButton";
import { urlClient } from "../../../utils/url";
import { OfferView } from "../offer-view";

export const OfferViewInClientPanel = () => {
  const {id} = useParams();

  return (
    <>
        <ViewNavigation>
            <Redirect>
                <GoBackButton
                    description={"Powrót"}
                    goToUrl={urlClient.orders}
                />
            </Redirect>
         </ViewNavigation>
         <OfferView
            offer_id_from_email={id}
        />
   </>
  );
};

const ViewNavigation = styled.div`
margin-top:-10px;
display: flex;
flex-direction: column;
@media (min-width: 1025px) {
 max-width: 1400px;
 margin-left: 225px;
 margin-right: 50px;
}`;

const Redirect = styled.div`
  display: flex;
  align-items: center;
 `;
  